<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useUserStore } from '@/stores'
import {
  PaymentMethodSelector,
  createShowPaymentMethodSelector,
  useFixedBottomPayment,
  usePurchase,
} from '@/composables/payment'
import { useFbqAddToCart } from '@/composables/fbq/useFbqAddToCart'

defineProps<{
  config: any
}>()

const user = useUserStore()

// 使用充值 composable（支持多支付方式）
const {
  templateProducts,
  PayTemplate,
  currentPaymentMethod,
  availablePaymentMethods,
  selectPaymentMethod,
} = usePurchase('store')

// 是否显示支付方式选择器
const showPaymentMethodSelector = createShowPaymentMethodSelector(availablePaymentMethods)

// 判断是否需要固定在底部
const { isFixedBottom, containerRef: payCoverRef, checkContentHeight } = useFixedBottomPayment()

// 监听支付方式切换，重新计算高度
watch(currentPaymentMethod, () => {
  checkContentHeight()
})

const { reportAddToCart } = useFbqAddToCart()
watch(templateProducts, (val) => {
  for (const p of val)
    reportAddToCart(p.productId, 'Coins Package', p.price ?? 0)
})

const active = ref(0)
function paySubmit(item: any, index: number) {
  active.value = index
  PayTemplate(item)
}
</script>

<template>
  <div>
    <BasicNavbar class="color-n-text-2" />

    <!-- Cover -->
    <div ref="payCoverRef" class="pay-cover mt-44px mb-24px mx-10px b-rd-2">
      <div class="pt-18px px-26px">
        <p class="flex items-center space-x-5px">
          <span class="text-18px text-n-primary font-bold">{{ user.$state.coinBalance }}</span>
          <span class="relative text-12px text-n-text-2">{{ config.texts.coins }}</span>
        </p>
      </div>

      <div :class="`pay-template pt-2px ${!isFixedBottom ? 'pb-0px' : 'pb-12px'}`">
        <!-- 充值 -->
        <div
          v-for="(item, index) in templateProducts"
          :key="item.productId"
          class="pay-template-info flex items-center space-x-15px mt-10px mx-10px px-16px py-16px b-rd-2 bg-n-bg-card border border-color-#2C2B2D"
          :class="{ 'border-color-#FF6B6B': active === index }"
          @click="paySubmit(item, index)"
        >
          <div>
            <img class="w-24px h-24px" :src="config.resources.goldCoinIcon">
          </div>
          <div class="flex-1">
            <div>
              <strong class="text-18px text-n-text-1">{{ item.coinsBuy }}</strong>
              <span class="ml-5px text-14px text-n-text-2">{{ config.texts.coins }}</span>
            </div>
            <div class="flex items-center">
              <span class="text-14px text-n-primary">+{{ item.coinsBonus }} {{ config.texts.coins }}</span>
              <i v-if="item.cornerTip === 1 && item.marketingText" class="inline-block ml-10px px-9px bg-pink b-rd-12px text-n-text-inverse text-10px font-not-italic">{{ item.marketingText }}</i>
            </div>
          </div>
          <div class="text-right">
            <strong class="text-18px text-n-text-1">$ {{ item.price }}</strong>
            <p v-if="item.cornerTip" class="text-12px text-n-text-2">
              +{{ parseFloat((item.coinsBonus / item.coinsBuy * 100).toFixed(2)) }}% {{ config.texts.coins }}
            </p>
          </div>
        </div>
      </div>

      <!-- 支付方式选择器 - 动态位置 -->
      <div
        v-if="showPaymentMethodSelector"
        class="flex justify-center"
        :class="[
          isFixedBottom ? 'fixed bottom-0px left-0 right-0 z-50' : 'px-10px mb-12px',
        ]"
      >
        <PaymentMethodSelector
          variant="large"
          dark
          :model-value="currentPaymentMethod"
          :available-methods="availablePaymentMethods"
          @update:model-value="selectPaymentMethod"
        />
      </div>

      <div :class="`${isFixedBottom ? 'pb-60px' : 'pb-20px'} px-16px text-10px text-n-text-3`">
        <p class="text-12px mt-6px">
          {{ config.texts.tips }}
        </p>
        <p class="mt-6px">
          {{ config.texts.tip1 }}
        </p>
        <p class="mt-6px">
          {{ config.texts.tip2 }}
        </p>
        <p class="mt-6px">
          {{ config.texts.tip3 }}
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pay-cover {
  min-height: calc(100vh - 68px);
}
</style>
